/**
 * PlayerContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

const PlayerContainer = styled.div<React.CSSProperties>`
  background: ${Colors.background};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
`;

export default withOpacity(PlayerContainer);
